export interface CarouselInfoCardData {
  id: string;
  pointerPosition: CarouselInfoCardPointerPosition;
  headerTitle?: string;
  bodyTitle?: string;
  // If nextTitle is provided, it will be used to display the next title.
  // Otherwise, the next title will be headerTitle, if provided, or bodyTitle, if headerTitle is not provided
  nextTitle?: string;
  description?: string | Array<string>;
  imageSrc?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  tertiaryButtonText?: string;
  primaryButtonAction?: () => void;
  secondaryButtonAction?: () => void;
  tertiaryButtonAction?: () => void;
}

export enum CarouselInfoCardEvents {
  CLOSE = 'info-card-close',
  PREVIOUS = 'info-card-previous',
  NEXT = 'info-card-next',
  PRIMARY_ACTION = 'info-card-primary-action',
  SECONDARY_ACTION = 'info-card-secondary-action',
  TERTIARY_ACTION = 'info-card-tertiary-action',
}

export enum CarouselInfoCardPointerPosition {
  TOP_BORDER_LEFT_SIDE = 'top-border-left-side',
  TOP_BORDER_RIGHT_SIDE = 'top-border-right-side',
  BOTTOM_BORDER_LEFT_SIDE = 'bottom-border-left-side',
  BOTTOM_BORDER_RIGHT_SIDE = 'bottom-border-right-side',
  LEFT_BORDER_UPPER_SIDE = 'left-border-upper-side',
  LEFT_BORDER_LOWER_SIDE = 'left-border-lower-side',
  RIGHT_BORDER_UPPER_SIDE = 'right-border-upper-side',
  RIGHT_BORDER_LOWER_SIDE = 'right-border-lower-side',
}

export interface CarouselInfoCardStrings {
  nextButtonText: string;
  nextTitlePrefix: string;
}
